import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import CharmLogo from '../../assets/charm-logo.png';
import { useUser } from '../../UserContext';
import { signOut, fetchUserAttributes } from 'aws-amplify/auth';
import ProfileDetails from "./Components/ProfileDetails/ProfileDetails";
import UnapprovedVendorProfileDropdown from "./UnapprovedVendorProfileDropdown";

const UnapprovedVendor = () => {
    const navigate = useNavigate();
    const { userStatus, isSignedIn, setIsSignedIn, user } = useUser();

    const [vendorName, setVendorName] = useState('');
    const [vendorId, setVendorId] = useState('');
    const [vendorEmail, setVendorEmail] = useState('');

    useEffect(() => {
        const checkUser = async () => {
            try {
                const userAttributes = await fetchUserAttributes();
                setVendorName(user['company_name']);
                setVendorId(userAttributes['custom:vendorId']);
                setVendorEmail(userAttributes['email']);
            } catch (error) {
            }
        };
        checkUser();
    }, []);

    const handleLogo = () => {
        navigate("/");
    };

    const handleLogout = async () => {
        try {
            await signOut();
            setIsSignedIn(false);
            navigate('/vendors');
        } catch (error) {
        }
    };

    // Check userStatus to see if the user is PENDING or not
    useEffect(() => {
        if (userStatus !== 'PENDING') {
            navigate('/vendors/loading');
        }
    }, []);


    return (
        <div className='w-full flex flex-col'>
            <div className="w-full h-[60px] bg-[#26051C] flex flex-row justify-between items-center px-basePx xs:px-xsPx 1.5xl:py-[18px] 1.5xl:px-[104px]">
                <button onClick={handleLogo} className="w-[248px] min-w-[248px] xl:w-[280px]">
                    <img
                        src={'https://charmhealth-marketplace-assets.s3.amazonaws.com/Homepage/charmhealthhub_logo_wht_ylw.png'}
                        alt="Logo"
                        className="w-full"
                    />
                </button>
                <UnapprovedVendorProfileDropdown />
            </div>

            <div className="mt-[32px] w-full flex flex-col px-basePx xs:px-xsPx 1.5xl:px-[104px]">
                <h4 className='font-allroundgothic font-[700] text-[24px] text-[#505050] mb-0' style={{ lineHeight: '1.35' }}>Thank you for signing up to be a vendor with CharmHealthHub!</h4>
                <p className='mt-[16px] font-proximanova text-[18px] text-[#505050] mb-0' style={{ lineHeight: '1.35' }}>We have received your application and are currently reviewing it. You can edit your account details here, but you won’t be able to create a listing until your application is approved.</p>
            </div>

            <div className="w-full px-basePx xs:px-xsPx 1.5xl:px-[104px]">
                <ProfileDetails vendorNavHidden={true} />
            </div>
        </div >
    );
}

export default UnapprovedVendor;
